var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-content',[(!_vm.logged_in)?[(_vm.adminLogin)?_c('staff-login',{attrs:{"changeLogin":_vm.changeLogin}}):_vm._e(),_vm._v(" "),(!_vm.adminLogin)?_c('login-component',{attrs:{"changeLogin":_vm.changeLogin}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.logged_in)?_c('page-container'):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e0baf9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 418
// module chunks = 0